module.exports = __webpack_public_path__ + "img/next-arrow.27fe8307.svg";